import PropTypes from 'prop-types'
import { CloseIcon } from '../../assets/svgs/icons'
import { ModalComponent } from '../../components/ModalComponent'
import styles from './styles.module.css'

export const MessagePopUp = ({
  logo,
  title,
  isOpen,
  content,
  primaryButton,
  secondaryButton,
  onClickPrimaryBtn,
  onClickSecondaryBtn,
  onClose
}) => {
  return (
    <ModalComponent
      isOpen={isOpen}
      className={styles.modalContainer}
    >
      <div
        className={styles.modalContentContainer}
      >
        {onClose &&
          <button
            onClick={onClose}
            className={styles.closeButtonContainer}
          ><CloseIcon color='#000' size='28px' /></button>}
        <div className={styles.logo_container}>
          <img src={logo} alt="logo" />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            textAlign: 'justify',
            gap: '20px'
          }}
        >
          <h1

          >
            {title}
          </h1>

          <p className={styles.modalContentContainerText}>
            {content}
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div
            onClick={onClickPrimaryBtn}
            style={{
              boxShadow: '0px 14px 40px 2px #6A009890',
              borderRadius: '40px', // Adicionando border-radius para acompanhar o botão
            }}
          >
            <button
              className={styles.primaryButton}>
              {primaryButton}
            </button>
          </div>

          <button
            onClick={onClickSecondaryBtn}
            className={styles.secondaryButton}
          >
            {secondaryButton}
          </button>
        </div>
      </div>
    </ModalComponent>
  )
}

MessagePopUp.propTypes = {
  logo: PropTypes.node,
  title: PropTypes.node,
  content: PropTypes.node,
  primaryButton: PropTypes.node,
  secondaryButton: PropTypes.node,
  onClickPrimaryBtn: PropTypes.func,
  onClickSecondaryBtn: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}